import { createSelector } from '@reduxjs/toolkit';
import { BatchesState } from 'ducks/batches/slices';
import { RootState } from 'store';

const batchesSlice = (state: RootState) => state.batches;

export const selectBatches = createSelector([batchesSlice], (state): BatchesState => state);
